"use strict";
var documenteditorDirective = function($parse, $compile) {
  return {
    restrict: 'E',
    scope: true,
    controller: require('../controllers/documenteditorCtrl'),
    link: function($scope, element, attrs) {
      var parsed = $parse(attrs.data);
      $scope.data = parsed($scope, {});
      $scope.$watch(attrs.data, function() {
        $scope.data = parsed($scope, {});
      });
    }
  };
};
documenteditorDirective.$inject = ['$parse', '$compile'];
module.exports = documenteditorDirective;
